/* eslint-disable no-restricted-syntax */
export const asyncNoop = async () => {};

export default () => {};
